import { addDays } from '../utils/dateFunctions';
import { DefaultField, IField } from './Field';
import { DefaultPrediction, IPrediction_v0 } from './Predictions';

export interface IEvent {
  id: string,
  resourceId: string,
  resourceName: string,
  allDay: boolean,
  editable: boolean,
  startEditable: boolean,
  durationEditable: boolean,
  resourceEditable: boolean,
  display: 'auto' | 'block' | 'list-item' | 'background' | 'inverse-background'| 'none'

  title: string,
  groupId: string,
  textColor?: string
  borderColor?: string,
  backgroundColor?: string,
  background?: string,
  start: string,
  end: string,
  percent?: number,

  eventType: 'pollination' | 'collection' | 'weather'
  fieldInfo: IField,
  prediction: IPrediction_v0,
}

export const default_event: IEvent = {
  id: '',
  resourceId: '',
  resourceName: '',
  title: '',
  groupId: '',
  allDay: true,
  editable: false,
  startEditable: false,
  durationEditable: false,
  resourceEditable: false,
  display: 'block',
  textColor: 'white',
  start: addDays(new Date(), 0).toISOString(),
  end: addDays(new Date(), 0).toISOString(),
  percent: 0.0,

  eventType: 'pollination',
  fieldInfo: DefaultField,
  prediction: DefaultPrediction,
}

export const default_pollination_event: IEvent = {
  ...default_event,
  eventType: 'pollination',
}

export const default_collection_event: IEvent = {
  ...default_event,
  eventType: 'collection',
}

export const default_weather_event: IEvent = {
  ...default_event,
  eventType: 'weather',
}
